import { Component } from '@angular/core';
import { ICellRendererAngularComp } from 'ag-grid-angular';
import { ICellRendererParams } from 'ag-grid-community';
import { Config } from 'src/app/config';
import { CommonService } from 'src/app/services/common.service';
import { MediaContentService } from 'src/app/services/media-content.service';
import { ColIdEnum, ReportStaticValues } from 'src/app/services/reports.service';

@Component({
  selector: 'grid-export-form-submission-button',
  template: `<button mat-button vrm-button fxFlex *ngIf="isDownloadable; else showCurrentValue" (click)="exportFile()">
      {{ 'REPORTDATA.download' | translate }}
    </button>
    <ng-template #showCurrentValue>{{ currentValue }}</ng-template> `,
  styles: [
    `
      button {
        color: white;
        font-size: 12px;
        line-height: 1;
        height: 24px;
        margin-top: 3px;
      }
    `,
  ],
})
export class GridDownloadReportFileButtonComponent implements ICellRendererAngularComp {
  private fileName: string;
  private exportUrl: string;
  public isDownloadable: boolean;
  public currentValue?: string;

  constructor(private cService: CommonService, private mediaContentService: MediaContentService) {}

  public agInit(params: { value: string; data: any; column?: any }) {
    this.currentValue = this.cService.getSingleTranslation(`REPORTDATA.${params.value}`, params.value);
    this.setIsDownloadable(params);
    this.setExportUrl(params);
    this.setFileName(params);
  }

  private setIsDownloadable(params): void {
    if (params?.column?.colId === ColIdEnum.exportDERSubmission) {
      this.isDownloadable = [ReportStaticValues.awaitingReview, ReportStaticValues.completed].includes(
        params.data.derStatus.toLowerCase()
      );
    }

    if (params?.column?.colId === ColIdEnum.exportIDDReport) {
      this.isDownloadable =
        [ReportStaticValues.awaitingReview, ReportStaticValues.completed].includes(
          params.data.derStatus.toLowerCase()
        ) && params.data.iddDocumentId;
    }
  }

  private setExportUrl(params: any): void {
    if (params?.column?.colId === ColIdEnum.exportDERSubmission) {
      this.exportUrl = `${Config.apiRoot.uri}/reports/driver_event_reporting/export/${params.data.pin}/${params.data.submissionId}/${this.cService.selectedLanguage.code}`;
    }

    if (params?.column?.colId === ColIdEnum.exportIDDReport) {
      this.exportUrl = `${Config.apiRoot.uri}/documents/view/${params.data.iddDocumentId}`;
    }
  }

  private setFileName(params: any): void {
    if (params?.column?.colId === ColIdEnum.exportDERSubmission) {
      this.fileName = `DER-${params.data.question_vehicle_identifier}-${params.data.submissionId}.zip`;
    }

    if (params?.column?.colId === ColIdEnum.exportIDDReport) {
      this.fileName = `IDD-${params.data.question_vehicle_identifier}-${params.data.submissionId}.pdf`;
    }
  }

  public exportFile() {
    this.mediaContentService.downloadBlobFromUrl(this.exportUrl, this.fileName, true);
  }

  refresh(params: ICellRendererParams): boolean {
    return false;
  }
}
